function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { utils as utils_exports, DEFAULTS, TypedEvent, AbstractPlugin, PSVError, events as events_exports$1 } from '../core/index.module.js';
/*!
 * PhotoSphereViewer.ResolutionPlugin 5.0.1
 * @copyright 2022 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */

var __defProp = Object.defineProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
}; // src/events.ts


var events_exports = {};

__export(events_exports, {
  ResolutionChangedEvent: function ResolutionChangedEvent() {
    return _ResolutionChangedEvent2;
  }
});

var _ResolutionChangedEvent = /*#__PURE__*/function (_TypedEvent) {
  _inherits(_ResolutionChangedEvent, _TypedEvent);

  var _super = _createSuper(_ResolutionChangedEvent);

  function _ResolutionChangedEvent(resolutionId) {
    var _this;

    _classCallCheck(this, _ResolutionChangedEvent);

    _this = _super.call(this, _ResolutionChangedEvent.type);
    _this.resolutionId = resolutionId;
    return _this;
  }

  return _createClass(_ResolutionChangedEvent);
}(TypedEvent);

var _ResolutionChangedEvent2 = _ResolutionChangedEvent;
_ResolutionChangedEvent2.type = "resolution-changed";
var getConfig = utils_exports.getConfigParser({
  resolutions: null,
  defaultResolution: null,
  showBadge: true
});

var _ResolutionPlugin = /*#__PURE__*/function (_AbstractPlugin) {
  _inherits(_ResolutionPlugin, _AbstractPlugin);

  var _super2 = _createSuper(_ResolutionPlugin);

  function _ResolutionPlugin(viewer, config) {
    var _this2;

    _classCallCheck(this, _ResolutionPlugin);

    _this2 = _super2.call(this, viewer);
    _this2.resolutions = [];
    _this2.resolutionsById = {};
    _this2.state = {
      resolution: null
    };
    _this2.config = getConfig(config);

    if (_this2.config.defaultResolution && _this2.viewer.config.panorama) {
      utils_exports.logWarn("ResolutionPlugin, a defaultResolution was provided but a panorama is already configured on the viewer, the defaultResolution will be ignored.");
    }

    return _this2;
  }

  _createClass(_ResolutionPlugin, [{
    key: "init",
    value: function init() {
      var _this3 = this;

      _get(_getPrototypeOf(_ResolutionPlugin.prototype), "init", this).call(this);

      this.settings = this.viewer.getPlugin("settings");

      if (!this.settings) {
        throw new PSVError("Resolution plugin requires the Settings plugin");
      }

      this.settings.addSetting({
        id: _ResolutionPlugin.id,
        type: "options",
        label: this.viewer.config.lang.resolution,
        current: function current() {
          return _this3.state.resolution;
        },
        options: function options() {
          return _this3.resolutions;
        },
        apply: function apply(resolution) {
          return _this3.__setResolutionIfExists(resolution);
        },
        badge: !this.config.showBadge ? null : function () {
          return _this3.state.resolution;
        }
      });
      this.viewer.addEventListener(events_exports$1.PanoramaLoadedEvent.type, this);

      if (this.config.resolutions) {
        this.setResolutions(this.config.resolutions, this.viewer.config.panorama ? null : this.config.defaultResolution);
        delete this.config.resolutions;
        delete this.config.defaultResolution;
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(events_exports$1.PanoramaLoadedEvent.type, this);
      this.settings.removeSetting(_ResolutionPlugin.id);

      _get(_getPrototypeOf(_ResolutionPlugin.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof events_exports$1.PanoramaLoadedEvent) {
        this.__refreshResolution();
      }
    }
  }, {
    key: "setResolutions",
    value: function setResolutions(resolutions, defaultResolution) {
      var _this4 = this;

      this.resolutions = resolutions || [];
      this.resolutionsById = {};
      resolutions.forEach(function (resolution) {
        if (!resolution.id) {
          throw new PSVError("Missing resolution id");
        }

        if (!resolution.panorama) {
          throw new PSVError("Missing resolution panorama");
        }

        _this4.resolutionsById[resolution.id] = resolution;
      });

      if (!this.viewer.config.panorama && !defaultResolution) {
        defaultResolution = resolutions[0].id;
      }

      if (defaultResolution && !this.resolutionsById[defaultResolution]) {
        utils_exports.logWarn("Resolution ".concat(defaultResolution, " unknown"));
        defaultResolution = resolutions[0].id;
      }

      if (defaultResolution) {
        this.setResolution(defaultResolution);
      }

      this.__refreshResolution();
    }
  }, {
    key: "setResolution",
    value: function setResolution(id) {
      if (!this.resolutionsById[id]) {
        throw new PSVError("Resolution ".concat(id, " unknown"));
      }

      return this.__setResolutionIfExists(id);
    }
  }, {
    key: "__setResolutionIfExists",
    value: function __setResolutionIfExists(id) {
      if (this.resolutionsById[id]) {
        return this.viewer.setPanorama(this.resolutionsById[id].panorama, {
          transition: false,
          showLoader: false
        });
      } else {
        return Promise.resolve();
      }
    }
  }, {
    key: "getResolution",
    value: function getResolution() {
      return this.state.resolution;
    }
  }, {
    key: "__refreshResolution",
    value: function __refreshResolution() {
      var _this5 = this;

      var resolution = this.resolutions.find(function (r) {
        return utils_exports.deepEqual(_this5.viewer.config.panorama, r.panorama);
      });

      if (this.state.resolution !== (resolution === null || resolution === void 0 ? void 0 : resolution.id)) {
        var _this$settings;

        this.state.resolution = resolution === null || resolution === void 0 ? void 0 : resolution.id;
        (_this$settings = this.settings) === null || _this$settings === void 0 ? void 0 : _this$settings.updateButton();
        this.dispatchEvent(new _ResolutionChangedEvent2(this.state.resolution));
      }
    }
  }]);

  return _ResolutionPlugin;
}(AbstractPlugin);

var ResolutionPlugin = _ResolutionPlugin;
ResolutionPlugin.id = "resolution"; // src/index.ts

DEFAULTS.lang.resolution = "Quality";
export { ResolutionPlugin, events_exports as events };
//# sourceMappingURL=index.module.js.map
